import sdl from '@jds/react-generated-sdl/JDSHeaderMobile';
import type { JDSHeaderMobileProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSHeaderMobileProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    search = true,
    expandedSearch = true,
    searchActive = false,
    searchButtonAriaLabel = props.dynamicButtonText?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { search, expandedSearch, searchActive, searchButtonAriaLabel, ...rest },
    'JDSHeaderMobile',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const HeaderMobile = withLogic(Component) as React.FC<JDSHeaderMobileProps> & {
  slotName?: string;
};

HeaderMobile.displayName = 'HeaderMobile';
HeaderMobile.slotName = 'jds_header_mobile';

export { HeaderMobile, type JDSHeaderMobileProps };
